import React, { FC, useEffect, useState } from 'react';
import 'whatwg-fetch';
import Select from 'react-select';
import useAuth from '../../../hooks/api/useAuth';

const apiEmployeeShow = '/api/employee/';
const apiProviders = '/api/providers/';

interface Props {
  onClose: () => void;
  isOpen: boolean;
  onSubmit: (employeeId?: number, providerId?: string) => void;
  openToast: (success: boolean, message: string) => void;
}

const PreparationToInstallationModal: FC<Props> = ({ onClose, isOpen, openToast, onSubmit }) => {
  const [employees, setEmployees] = useState();
  const [providers, setProviders] = useState();
  const [employeeSelectedId, setEmployeeSelectedId] = useState<number>();
  const [providerSelectedId, setProviderSelectedId] = useState<string>();
  const { fetch } = useAuth();

  const handleEmployeeChange = (employee?: Record<string, any>) => {
    setEmployeeSelectedId(employee?.id);
  };

  const handleProviderChange = (provider?: Record<string, any>) => {
    setProviderSelectedId(provider?.id);
  };

  const fetchEmployees = () => {
    let queryURL = apiEmployeeShow;
    const graphQL = '{ employees{ id, firstname, lastname } }';
    queryURL += graphQL;
    return fetch(queryURL, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'GET',
    }).then((resp) => resp.json());
  };

  const fetchProviders = () => {
    return fetch(apiProviders, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'GET',
    }).then((resp) => resp.json());
  };

  useEffect(() => {
    fetchProviders().then((data) => setProviders(data));
    fetchEmployees().then((data) => setEmployees(data.data.employees));
  }, []);

  const checkFormValid = () => {
    return employeeSelectedId || providerSelectedId;
  };

  const handleSubmit = () => {
    if (onSubmit) {
      if (checkFormValid()) {
        onSubmit(employeeSelectedId, providerSelectedId);
        onClose();
      } else {
        openToast(false, 'Certains champs obligatoires sont vides');
      }
    }
  };

  if (!isOpen) return null;

  return (
    <div className='modal myModal'>
      <div className='modal-dialog modal-md'>
        <div className='modal-content'>
          <div className='modal-header'>
            <h4 className='modal-title'>Étape suivante</h4>
            <button onClick={onClose} type='button' className='close' data-dismiss='modal' aria-label='Close'>
              <span aria-hidden='true'>&times;</span>
            </button>
          </div>
          <form>
            <div className='modal-body'>
              <p>
                Vous allez faire passer l'affaire en installation. <br />
                Veuillez sélectionner la personne en charge de l'installation.
              </p>
              <div className='form-group'>
                <label>Employé</label>
                <Select
                  className='inputModalSelect'
                  value={employeeSelectedId}
                  labelKey='firstname'
                  valueKey='id'
                  options={employees}
                  onChange={handleEmployeeChange}
                  noResultsText='Aucun résultat'
                  placeholder='Nom'
                  clearValueText='Supprimer'
                />
              </div>

              <div className='form-group'>
                <label>Prestataire</label>
                <Select
                  className='inputModalSelect'
                  value={providerSelectedId}
                  labelKey='name'
                  valueKey='id'
                  options={providers}
                  onChange={handleProviderChange}
                  noResultsText='Aucun résultat'
                  placeholder='Nom'
                  clearValueText='Supprimer'
                />
              </div>
            </div>
            <div className='modal-actions'>
              <button onClick={onClose} type='button' className='btn-link modal-action' data-dismiss='modal'>
                Annuler
              </button>
              <button onClick={handleSubmit} type='button' className='btn-link modal-action' data-dismiss='modal'>
                <strong>Valider</strong>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default PreparationToInstallationModal;
